import React, { useState, useEffect } from "react";
import "./App.css";
import Axios from "axios";

import * as Firebase from "firebase";

const App: React.FC = () => {
  // @TODO extract this to env (security)
  const FirebaseConfig = {
    apiKey: "AIzaSyDqHajVAXd7B7-PiSTWJFt_fLj9clf6bVs",
    authDomain: "caltex-users-production.firebaseapp.com",
    databaseURL: "https://caltex-users-production.firebaseio.com",
    projectId: "caltex-users-production",
    storageBucket: "caltex-users-production.appspot.com",
    messagingSenderId: "607687286433",
    appId: "1:607687286433:web:f7135e4c285340a0919ae0"
  };
  const AppConfig = {
    baseUrl: "https://api-production.caltexaasf.co.nz"
  };
  if (!Firebase.apps.length) {
    Firebase.initializeApp(FirebaseConfig);
  }

  const [authenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState<string | undefined>(undefined);
  const [user, setUser] = useState<any>(undefined);
  const [connectedToRemoteConfig, setConnectedToRemoteConfig] = useState(false);
  const [connectedToPump, setConnectedToPump] = useState(false);

  const [pumpedStatus, setPumpedStatus] = useState<any>(undefined);

  const [error, setError] = useState<any>(undefined);

  useEffect(() => {
    if (authenticated && token && !user) {
      const client = Axios.create({
        baseURL: `https://cors-anywhere.herokuapp.com/${AppConfig.baseUrl}`
        // baseURL: AppConfig.baseUrl
      });

      client
        .get("/users", {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "App-Version": "3.0.0"
          }
        })
        .then(response => {
          if (response.data) {
            setUser(response.data);
          }
        })
        .catch(error => {
          setError(`Users call failed - ${error}`);
        });

      Firebase.remoteConfig()
        .fetchAndActivate()
        .then(() => {
          setConnectedToRemoteConfig(true);
          console.log(Firebase.remoteConfig().getAll());
        })
        .catch(err => {
          setError(err);
        });
    }
  }, [authenticated, token, AppConfig, user]);

  useEffect(() => {
    if (user && !connectedToPump) {
      const client = Axios.create({
        baseURL: `https://cors-anywhere.herokuapp.com/${AppConfig.baseUrl}`
        // baseURL: AppConfig.baseUrl
      });

      client
        .get(`/pumped_balance`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "App-Version": "3.0.0"
          }
        })
        .then(response => {
          setPumpedStatus(response);
          if (response.status) {
            setConnectedToPump(true);
          }
        })
        .catch(error => {
          setError(`Pumped balance call failed - ${error}`);
        });
    }
  }, [user, AppConfig.baseUrl, connectedToPump, token]);

  const handleOnFacebookSignInClick = () => {
    const provider = new Firebase.auth.FacebookAuthProvider();

    Firebase.auth()
      .signInWithPopup(provider)
      .then(async result => {
        console.log(result);
        setAuthenticated(true);
        if (result.credential && result.user) {
          const token = await result.user.getIdToken();
          console.log(token);
          setToken(token);

          // setToken(result.credential.toJSON());
        }
      })
      .catch(error => {
        console.log(error);
        setAuthenticated(false);
      });
  };

  const handleOnGoogleSignInClick = () => {
    const provider = new Firebase.auth.GoogleAuthProvider();

    Firebase.auth()
      .signInWithPopup(provider)
      .then(async result => {
        console.log(result);
        setAuthenticated(true);
        if (result.credential && result.user) {
          const token = await result.user.getIdToken();
          console.log(token);
          setToken(token);

          // setToken(result.credential.toJSON());
        }
      })
      .catch(error => {
        console.log(error);
        setError(error);
        setAuthenticated(false);
      });
  };

  if (authenticated) {
    return (
      <div className="App">
        <header className="App-header">
          <span className="label">Authenticated</span>
          {connectedToRemoteConfig && (
            <span className="label">Connected to Remote Config</span>
          )}
          {pumpedStatus && (
            <span className="label">Pumped Status: {pumpedStatus.status}</span>
          )}
          {error && <span className="label">Error: {`${error}`}</span>}
        </header>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="block">
          <button onClick={handleOnGoogleSignInClick} className="myButton">
            Sign in with Google
          </button>
          <button onClick={handleOnFacebookSignInClick} className="myButton">
            Sign in with Facebook
          </button>
        </div>
      </header>
    </div>
  );
};

export default App;
